import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";
import AllVisaPublicScreen  from "./screens/AllVisaPublicScreen";

const DashboardScreen = lazy(() => import("./screens/DashboardScreen"));
const LoginScreen = lazy(() => import("./screens/LoginScreen"));
const AddUserScreen = lazy(() => import("./screens/AddUserScreen"));
const UserProfileScreen = lazy(() => import("./screens/UserProfileScreen"));
const AddGeneralDataScreen = lazy(() =>
  import("./screens/AddGeneralDataScreen")
);
const AllGeneralDataScreen = lazy(() =>
  import("./screens/AllGeneralDataScreen")
);
const SearchGeneralScreen = lazy(() => import("./screens/SearchGeneralScreen"));
const UpdateGeneralScreen = lazy(() => import("./screens/UpdateGeneralScreen"));
const ViewGeneralScreen = lazy(() => import("./screens/ViewGeneralScreen"));
const AllUsersScreen = lazy(() => import("./screens/AllUsersScreen"));
const SearchUserScreen = lazy(() => import("./screens/SearchUserScreen"));
const SearchBrokerScreen = lazy(() => import("./screens/SearchBrokerScreen"));
const SearchMedicalScreen = lazy(() => import("./screens/SearchMedicalScreen"));
const UpdateUserScreen = lazy(() => import("./screens/UpdateUserScreen"));
const AddMedicalDataScreen = lazy(() => import("./screens/AddMedicalDataScreen"));
const AllMedicalDataScreen = lazy(() => import("./screens/AllMedicalDataScreen"));
const ViewMedicalScreen = lazy(() => import("./screens/ViewMedicalScreen"));
const UpdateMedicalSreen = lazy(() => import("./screens/UpdateMedicalSreen"));
const AddBrokerDataScreen = lazy(() => import("./screens/AddBrokerDataScreen"));
const AllBrokerDataScreen = lazy(() => import("./screens/AllBrokerDataScreen"));
const ViewbrokerScreen = lazy(() => import("./screens/ViewbrokerScreen"));
const UpdateBrokerScreen = lazy(() => import("./screens/UpdateBrokerScreen"));
const AllAppUsers = lazy(() => import("./screens/AllAppUserScreen"));
const AllVisaScreen = lazy(() => import("./screens/AllVisaScreen"));
const AddVisaDataScreen = lazy(() => import("./screens/AddVisaDataScreen"));
const UpdateVisaScreen = lazy(() => import("./screens/UpdateVisaScreen"));
const AddXrayScreen = lazy(() => import("./screens/AddXrayScreen"));
const AllXrayDataScreen = lazy(() => import("./screens/AllXrayDataScreen"));
const AllXrayRepotedScreen = lazy(() => import("./screens/AllRepotedXrayScreen"));
const ViewXrayScreen = lazy(() => import("./screens/ViewXrayScreen"));
const UpdateXrayScreen = lazy(() => import("./screens/UpdateXrayScreen"));
const SearchXrayDataScreen = lazy(() => import("./screens/SearchXrayScreen"));
const AddFitunfitScreen = lazy(() => import("./screens/AddFitunfitScreen"));
const AllFitunfitDataScreen = lazy(() => import("./screens/AllFitunfitDataScreen"));
const ViewFitunfitScreen = lazy(() => import("./screens/ViewFitunfitScreen"));
const AllFitReportDataScreen = lazy(() => import("./screens/AllFitReportDataScreen"));
const ViewFitDataScreen = lazy(() => import("./screens/ViewFitDataScreen"));
const AllHoldVisitReportDataScreen = lazy(() => import("./screens/AllHoldVisitDataScreen"));
const SearchFitUnfitScreen = lazy(() => import("./screens/SearchFitUnfitScreen.js"));
const SearchFitUnfitAllDataScreen = lazy(() => import("./screens/SearchFitUnfitAllDataScreen.js"));
const AllinProgressDataScreen = lazy(() => import("./screens/AllinProgressDataScreen.js"));
const SearchInprogressDataScreen = lazy(() => import("./screens/SearchInprogressScreen.js"));
const AllAnotherXrayDataScreen = lazy(() => import("./screens/AllAnotherXrayDataScreen.js"));
const ViewAnotherXrayScreen = lazy(() => import("./screens/ViewAnotherXrayScreen.js"));
const UpdateAnotherXrayScreen = lazy(() => import("./screens/UpdateAnotherXrayScreen.js"));
const AllAnotherRepotedXrayScreen = lazy(() => import("./screens/AllAnotherRepotedXrayScreen.js"));
const searchAnotherXray = lazy(() => import("./screens/SearchAnotherXrayScreen.js"));
const AddLabReportDataScreen = lazy(() => import("./screens/AddLabReportDataScreen.js"));
const AllFitunfitTrashDataScreen = lazy(() => import("./screens/AllFitunfitTrashDataScreen.js"));
const SearchHoldVisitScreen = lazy(() => import("./screens/SearchHoldVisitScreen.js"));
const AllLabReportDatascreen = lazy(() => import("./screens/AllLabReportDataScreen.js"));
const ViewLabReportScreen = lazy(() => import("./screens/ViewLabReportDataScreen.js"));
const AddPhysicalDataScreen = lazy(() => import("./screens/AddPhysicalDataScreen.js"));
const AllUnfitDataScreen = lazy(() => import("./screens/AllUnfitDataScreen.js"));
const AllHoldDataScreen = lazy(() => import("./screens/AllHoldDataScreen.js"));

const ReportFrom = lazy(() => import("./screens/ReportFrom.js"));

function App() {
  return (
    <Router>
      <Suspense
        fallback={
          <Spinner
            animation="border"
            role="status"
            variant="primary"
            style={{
              width: "100px",
              height: "100px",
              margin: "auto",
              display: "block",
            }}
          >
            <span className="sr-only">Loading...</span>
          </Spinner>
        }
      >
        <Switch>
          <Route path="/login" component={LoginScreen} exact />
          <Route exact path="/visa" component={AllVisaPublicScreen}/>

          <div className="wrapper">
            <Header />
            <Sidebar />
            <Route path="/users/new" component={AddUserScreen} exact />
            <Route path="/users/profile" component={UserProfileScreen} exact />
            <Route path="/users" component={AllUsersScreen} exact />
            <Route path="/users/update" component={UpdateUserScreen} exact />
            <Route
              path="/users/search/:keyword/page/:pageNumber"
              component={SearchUserScreen}
              exact
            />

            <Route path="/users/app" component={AllAppUsers} exact/>

            <Route path="/forms/visa" component={AllVisaScreen} exact/>
            <Route path="/forms/visa/new" component={AddVisaDataScreen} exact/>

            <Route
              path="/forms/visa/update"
              component={UpdateVisaScreen}
              exact
            />

            <Route
              path="/broker/search/:keyword/page/:pageNumber"
              component={SearchBrokerScreen}
              exact
            />
            <Route
              path="/medical/search/:keyword/page/:pageNumber"
              component={SearchMedicalScreen}
              exact
            />
            <Route
              path="/forms/medical/new"
              component={AddMedicalDataScreen}
              exact
            />
            <Route
              path="/forms/medical"
              component={AllMedicalDataScreen}
              exact
            />
            <Route
              path="/forms/anotherxray/"
              component={AllAnotherXrayDataScreen}
              exact
            />
            <Route
              path="/forms/medical/view"
              component={ViewMedicalScreen}
              exact
            />
            <Route
              path="/forms/medical/update"
              component={UpdateMedicalSreen}
              exact
            />
            <Route
              path="/forms/broker/new"
              component={AddBrokerDataScreen}
              exact
            />
            <Route path="/forms/broker" 
              component={AllBrokerDataScreen} 
              exact 
            />

            <Route
              path="/forms/broker/view"
              component={ViewbrokerScreen}
              exact
            />
            <Route
              path="/forms/broker/update/"
              component={UpdateBrokerScreen}
              exact
            />

            <Route
              path="/reportfrom"
              component={ReportFrom}
            />

            <Route
              path="/forms/general/new"
              component={AddGeneralDataScreen}
              exact
            />
            <Route
              path="/forms/general"
              component={AllGeneralDataScreen}
              exact
            />
            <Route
              path="/general/search/:keyword/page/:pageNumber"
              component={SearchGeneralScreen}
              exact
            />
            <Route
              path="/forms/general/update"
              component={UpdateGeneralScreen}
              exact
            />
            <Route
              path="/forms/general/view"
              component={ViewGeneralScreen}
              exact
            />
            <Route
              path="/forms/xray/new"
              component={AddXrayScreen}
              exact
            />
            <Route
              path="/forms/medicalreport/new"
              component={AddFitunfitScreen}
              exact
            />
            <Route
              path="/forms/fitunfit"
              component={AllFitunfitDataScreen}
              exact
            />
            <Route
              path="/forms/fitunfit/view"
              component={ViewFitunfitScreen}
              exact
            />
            <Route
              path="/forms/fit/view"
              component={ViewFitDataScreen}
              exact
            />
            <Route
              path="/fitunfit/search/:keyword/:userid/page/:pageNumber"
              component={SearchFitUnfitScreen}
              exact
            />
            <Route
              path="/fitunfit/inprogress/search/:keyword/:userid/page/:pageNumber"
              component={SearchInprogressDataScreen}
              exact
            />
            <Route
              path="/fitunfitall/search/:keyword/:userid/page/:pageNumber"
              component={SearchFitUnfitAllDataScreen}
              exact
            />
            <Route
              path="/fitunfit/holdvisit/search/:keyword/:userid/page/:pageNumber"
              component={SearchHoldVisitScreen}
              exact
            />
            <Route
              path="/forms/xray"
              component={AllXrayDataScreen}
              exact
            />
            <Route
              path="/forms/xray/repoted"
              component={AllXrayRepotedScreen}
              exact
            />

            <Route
              path="/forms/xray/anotherrepoted"
              component={AllAnotherRepotedXrayScreen}
              exact
            />
            <Route
              path="/forms/status/fit"
              component={AllFitReportDataScreen}
              exact
            />
            <Route
              path="/forms/status/inprogress"
              component={AllinProgressDataScreen}
              exact
            />
            <Route
              path="/forms/status/holdvisit"
              component={AllHoldVisitReportDataScreen}
              exact
            />

            <Route
              path="/forms/status/unfit"
              component={AllUnfitDataScreen}
              exact
            />

            <Route
              path="/forms/status/hold"
              component={AllHoldDataScreen}
              exact
            />
            <Route
              path="/forms/xray/view"
              component={ViewXrayScreen}
              exact
            />
            <Route
              path="/forms/anotherxray/view"
              component={ViewAnotherXrayScreen}
              exact
            />
            <Route
              path="/forms/xray/update"
              component={UpdateXrayScreen}
              exact
            />
            <Route
              path="/forms/anotherxray/update"
              component={UpdateAnotherXrayScreen}
              exact
            />
             <Route
              path="/xray/search/:keyword/:userid/page/:pageNumber"
              component={SearchXrayDataScreen}
              exact
            />

           <Route
              path="/xray/anothersearch/:keyword/:userid/page/:pageNumber"
              component={searchAnotherXray}
              exact
            />

            <Route
              path="/lab/addreport"
              component={AddLabReportDataScreen}
              exact
            />

            <Route
              path="/forms/labreport"
              component={AllLabReportDatascreen}
              exact
            />

            <Route
              path="/forms/labreport/view"
              component={ViewLabReportScreen}
              exact
            />

            <Route
              path="/physical/addreport"
              component={AddPhysicalDataScreen}
              exact
            />

            <Route
              path="/trash"
              component={AllFitunfitTrashDataScreen}
              exact
            />

            <Route path="/" component={DashboardScreen} exact />
            <Footer/>
          </div>
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
